<template>
    <div class="upgrade-annual-toggle" v-if="targetPlan">
        <div class="annual-toggle">
            <div>
                <SwitchToggle :config="toggleConfig" @toggle="toggle"></SwitchToggle>
            </div>
            <!--START TEST CBSCOMSUB-10538 Upgrade to Premium on Payment-->
            <div class="subtitle-text" v-if="isUpgradePremiumToggle">
                <a class="payment-summary__legal-overlay-open" @click="handleModal">
                    {{ getSubTitle }}
                </a>
            </div>
            <!--Please remove v-else while removing a/b test code-->
            <!--END TEST CBSCOMSUB-10538 Upgrade to Premium on Payment-->
            <!-- CBSCOMSUB-10538 line ~19 text -> "v-else" is a part of a/b test, added only for a/b test and will remove when we will remove this a/b test -->
            <div class="subtitle-text" v-else>{{ getSubTitle }}</div>
        </div>
        <p class="upgrade-annual-disclaimer" v-show="showDisclaimer">
            {{ disclaimer }}
        </p>
    </div>
</template>

<script>
    import SwitchToggle from 'atoms/SwitchToggle';
    import { mapState, mapGetters } from 'vuex';
    import Product from 'aa/vue/models/Product';
    import Domain from 'helpers/Domain';
    import checkoutMixin from 'aa/vue/plugins/checkoutMixin';

    export default {
        name: 'UpgradeAnnualToggle',
        components: {
            SwitchToggle,
        },
        mixins: [checkoutMixin],
        props: {
            planType: {
                type: String,
            },
            attachedCoupon: {
                type: Object,
                default: null,
            },
            // START TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
            isUpgradePremiumToggle: {
                type: Boolean,
                required: false,
                default: false,
            },
            // END TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
        },
        computed: {
            ...mapState('pageAttributes', {
                pageAttr: (state) => state.attributes,
            }),

            ...mapGetters({
                plan: 'plan/getCurrentPlan',
                flowType: 'flow/type',
            }),

            disclaimer() {
                // START TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
                if (this.isUpgradePremiumToggle) {
                    return '†No ads except for Live TV';
                }
                // END TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
                return this.pageAttr?.aa_payment_upgrade_to_annual_disclaimer ?? '';
            },
            toggleConfig() {
                return {
                    id: 'toggle',
                    value: this.toggleValue,
                    displayTexts: {
                        Off: this.getTitle,
                        On: this.getTitle,
                    },
                };
            },

            toggleValue() {
                // START TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
                // we need here isUpgradePremiumToggle  because when promo apply we not need to reset toggle.
                if (this.isUpgradePremiumToggle) {
                    return false;
                }
                // END TEST CBSCOMSUB-10538 Upgrade to Premium on Payment

                return this.planType !== Product.TYPE_MONTHLY;
            },
            getSubTitle() {
                // START TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
                if (this.isUpgradePremiumToggle) {
                    return 'Learn more';
                }
                // END TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
                return this.showGenericCopy
                    ? (this.pageAttr?.aa_payment_upgrage_to_annual_sub_title_generic ?? '')
                    : (this.pageAttr?.aa_payment_upgrage_to_annual_sub_title ?? '');
            },
            getTitle() {
                // START TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
                if (this.isUpgradePremiumToggle) {
                    return this.getAbTestTitle;
                }
                // END TEST CBSCOMSUB-10538 Upgrade to Premium on Payment

                return this.showGenericCopy
                    ? (this.pageAttr?.aa_payment_upgrage_to_annual_title_generic ?? '')
                    : (this.pageAttr?.aa_payment_upgrage_to_annual_title ?? '');
            },
            // START TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
            selectedPlan() {
                return this.$store.getters['plan/getSelectedPlan'];
            },
            targetPlan() {
                if (!this.selectedPlan) {
                    return null;
                }

                return this.$store.getters['plan/getTargetPlanForUpgradeToggle']?.(
                    this.selectedPlan.planType === Product.TYPE_MONTHLY,
                    this.isUpgradePremiumToggle,
                );
            },
            getAbTestTitle() {
                return 'Watch Ad-Free with Premium†';
            },
            // END TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
            isInternational() {
                return Domain.isInternational();
            },
            hasPromoCode() {
                return this.$store.state.promo == null ? false : true;
            },
            isCoupon() {
                return this.attachedCoupon?.recurlyInfo?.code ?? false;
            },
            isCMSPromo() {
                return this.$store.state.isCMSPromo;
            },
            disclaimerManuallyHiddenCMS() {
                return this.pageAttr?.hideToggleDisclaimer;
            },
            validOfferKeys() {
                // return coupon code keys (offer_*_coupon_code) from page attributes
                return Object.keys(this.pageAttr).filter(
                    (k) =>
                        k.startsWith('offer_') &&
                        k.endsWith('_coupon_code') &&
                        this.pageAttr[k]?.trim() !== '',
                );
            },
            getCurrentCMSCoupons() {
                // return the coupon codes from the values in validOfferKeys, removing duplicates
                return [...new Set(this.validOfferKeys.map((key) => this.pageAttr[key]))];
            },
            plansWithCMSCoupons() {
                return this.validOfferKeys
                    .map((key) => {
                        let planCodeKey = key.replace('_coupon_code', '_product_code');
                        return this.pageAttr[planCodeKey]; // Return the value of the plan code
                    })
                    .filter((value) => value); // Filter out undefined or null values
            },
            showGenericCopy() {
                let isCurrentCouponNationalCampaign = this.getCurrentCMSCoupons.includes(
                    this.attachedCoupon?.recurlyInfo?.code,
                );

                let isDynamicCampaign = this.flowType?.startsWith('campaign_');

                return (
                    this.attachedCoupon?.recurlyInfo?.code ||
                    isCurrentCouponNationalCampaign ||
                    this.selectedPlan?.offerCouponCode ||
                    this.targetPlan?.offerCouponCode ||
                    isDynamicCampaign
                );
            },
            showDisclaimer() {
                let showGenericCopy = this.showGenericCopy;
                // START TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
                if (this.isUpgradePremiumToggle && showGenericCopy !== false) {
                    showGenericCopy = false;
                }
                // END TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
                return this.disclaimer && !this.disclaimerManuallyHiddenCMS && !showGenericCopy;
            },
        },
        methods: {
            toggle(action) {
                // START TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
                if (this.isUpgradePremiumToggle) {
                    this.$emit('filterAndSelect', action, this.isUpgradePremiumToggle);
                    return;
                }
                // END TEST CBSCOMSUB-10538 Upgrade to Premium on Payment

                this.$emit('filterAndSelect', action);
            },
            // START TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
            handleModal() {
                this.$emit('handleModal');
            },
            // END TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
        },
    };
</script>
